export const companyLogo = require("./media/logo/venti-maris-logo.png");
export const companyLogoOriginal = require("./media/logo/venti-maris-logo-original.png");
export const empireEngineeringLogo = require("./media/logo/Empire-Engineering-logo.png");
export const empireEngineeringVerticalLogo = require("./media/logo/Empire-Engineering-logo-vertical.png");

export const imgService1 = require("./media/background/shipping-wind-poles.jpg");
export const imgService2 = require("./media/background/wind-farm-construction2.jpeg");
export const imgService3 = require("./media/background/wind-farm-shipping1.jpeg");
export const imgService4 = require("./media/background/wind-farm-shipping2.jpeg");
export const imgService5 = require("./media/background/wind-farm-shipping3.jpeg");
export const imgService6 = require("./media/background/wind-farm-shipping4.jpeg");

export const imgCompany1 = require("./media/background/team.jpeg");
export const imgCompany2 = require("./media/background/customer-service.jpeg");
export const imgCompany3 = require("./media/background/work-space.jpeg");

export const imgHomgBg = require("./media/background/wind-farm.jpeg");
export const imgServiceBg = require("./media/background/wind-farm2.jpeg");

export const imgShipping = require("./media/background/shipping1.jpg");
export const imgWindFarm = require("./media/background/wind-farm-illustration.jpg");
export const imgGreenEarth = require("./media/background/green-earth.jpg");
export const imgSustainability = require("./media/illustrations/sustainability.jpg");
export const imgOfficeOnMap = require("./media/background/office-on-map.jpeg");

export const offshoreSubstation = require("./media/illustrations/offshore-substation.png");
export const windFarm = require("./media/illustrations/wind-farm-illustration.png");
